import React from 'react';
import { View, Text } from 'react-native';
import i18n from 'i18n-js';
import { connect } from 'react-redux';

import { toLogin } from '@reducers/utils';
import { scale } from '@components/frame';

import TouchableElement from '@components/common/touchableElement';

import ColorsWrapper from '@styles/colors';
import { font } from '@styles/fonts';
import Svg from '@styles/icons/svg';

const ConnectorEmail = ({ C, onBoarding }) => {
  const name = onBoarding?.registeredConnector?.tenantCompanyName;

  return (
    <View style={{ width: '100%', flex: 1, alignItems: 'center', backgroundColor: C('Background/Light/System') }}>
      <View
        style={{
          width: '100%',
          maxWidth: scale(360),
          paddingHorizontal: scale(29),
          flex: 1,
          paddingTop: scale(100),
          alignItems: 'center',
        }}
      >
        <View style={{ flex: 1 }}>
          <View style={{ alignItems: 'center' }}>
            <Svg icon="smartFactory" width={scale(140)} height={scale(70)} color={'Other/Light/Logo/Factory'} />
          </View>
          <Text style={[font.Body, { color: C('Label/Light/Primary'), marginTop: scale(45), textAlign: 'center' }]}>
            {i18n.t('Your Connector is linked to:')}
          </Text>
          <Text style={[font['Title 2'], { color: C('Label/Light/Primary'), marginVertical: scale(48), textAlign: 'center' }]}>{name}</Text>
          <Text style={[font.Body, { color: C('Label/Light/Primary'), marginVertical: scale(22), textAlign: 'center' }]}>
            {i18n.t('You can log in to your App using an existing user of {{name}}.', { name })}
          </Text>
          <Text style={[font.Body, { color: C('Label/Light/Primary'), textAlign: 'center' }]}>
            {i18n.t('If you don’t know any user, you can click on “Reset Connector” to setup this Connector.')}
          </Text>
        </View>
        <View style={{ paddingBottom: scale(110) }}>
          <TouchableElement
            onPress={() => {
              toLogin();
            }}
          >
            {({ boxStyle, pressHoverColor }) => (
              <View style={[boxStyle]}>
                <Text style={[font[' Button 2'], { color: C(pressHoverColor('Label / Light / Secondary')) }]}>{i18n.t('Back to start screen')}</Text>
              </View>
            )}
          </TouchableElement>
        </View>
      </View>
    </View>
  );
};

export default connect(({ onBoarding }) => ({ onBoarding }), {})(ColorsWrapper(ConnectorEmail));
